<template>
  <StructuredData id="schema-organization" :schema="organizationSchema" />
  <StructuredData id="schema-webpage" :schema="webPageSchema" />
  <template v-if="storeGlobal.isSeaAndNightUrl">
    <div>
      <BannerTopVideoPage is-home class="position-relative" />
      <div>
        <CardsViajesSelector class="mt-5 mb-3" />
        <CarouselMejoresAgrupaciones :agrupaciones="agrupaciones" />

        <PorqueReservar2 />
      </div>
    </div>
  </template>
  <template v-else>
    <div>
      <BannerTopPage>
        <div class="home-view banner-home row container text-white"></div>
      </BannerTopPage>

      <div>
        <AgrupacionesExperienciasCollection :agrupaciones="agrupaciones" />

        <template v-if="checkDomain([DOMAINS.skiandnight])">
          <BuscadorSectionHome />
          <PorqueReservar />
        </template>
      </div>
    </div>
  </template>
</template>

<script setup>
  import { onBeforeMount, ref } from 'vue';
  import { useRoute } from 'vue-router';
  import AgrupacionesExperienciasCollection from '@/components/home/AgrupacionesExperienciasCollection.vue';
  import BuscadorSectionHome from '@/components/home/BuscadorSectionHome.vue';
  import { useAgrupacionesStore } from '@/store_pinia/agrupaciones';
  import { appGlobalStore } from '@/store_pinia/app';
  import BannerTopPage from '@components/BannerTopPage.vue';
  import BannerTopVideoPage from '@components/BannerTopVideoPage.vue';
  import CarouselMejoresAgrupaciones from '@/components/Carousel/CarouselMejoresAgrupaciones.vue';
  import CardsViajesSelector from '@components/home/CardsViajesSelector.vue';
  import PorqueReservar from '@components/misc/PorqueReservar.vue';
  import PorqueReservar2 from '@components/misc/PorqueReservar2.vue';
  import { checkDomain, DOMAINS } from '@/helpers/domainUtils';
  import { saveComercialId } from '@/helpers/viajesGrupos';
  import { useLoadingStore } from '@/store_pinia/loadingStore';
  import StructuredData from '@/components/utils/StructuredData.vue';
  import { useStructuredData } from '@/composables/useStructuredData';
  import { usePageMeta } from '@/composables/usePageMeta';

  const route = useRoute();
  const loadingStore = useLoadingStore();
  const storeGlobal = appGlobalStore();
  const agrupacionesStore = useAgrupacionesStore();
  const agrupaciones = ref([]);
  const { organizationSchema } = useStructuredData();
  const { webPageSchema } = usePageMeta();

  async function init() {
    try {
      loadingStore.show();
      agrupaciones.value = await agrupacionesStore.fetchAgrupaciones();
      await saveComercialId(route.query.comercialId);
    } catch (error) {
      console.error(error);
    } finally {
      loadingStore.hide();
    }
  }

  onBeforeMount(async () => await init());
</script>

<style scoped>
  .home-view .banner-home {
    max-width: 800px;
    margin: auto;
    padding-top: 56px;
  }

  .home-view .banner-home__title {
    margin-bottom: 1rem;
    font-size: 40px !important;
  }
</style>
